import { SocialLinksEnum, getSocialLinkIcon } from '@systemeio/digital-store-shared'
import { FormInput, FormInputUrl, InputProps } from '@systemeio/ui'
import FormInputMedia from 'modules/stores/store/content/profile/components/form-input-media'
import {
  MEDIA_WHATSAPP,
  SCHEME,
  getSocialLinkLabel,
} from 'modules/stores/store/content/profile/utils/get-social-link-label'
import { getSocialLinkPlaceholder } from 'modules/stores/store/content/profile/utils/get-social-link-placeholder'
import React, { FC } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface FormInputSocialProps extends Omit<InputProps, 'value' | 'onChange'> {
  social: SocialLinksEnum
  value?: string
  onChange: (value: string) => void
}

const WHATSAPP_SCHEME = `${SCHEME}${MEDIA_WHATSAPP}/`

const FormInputSocial: FC<FormInputSocialProps> = ({ social, onChange, value = '', ...rest }) => {
  const { t } = useLocoTranslation()

  const getFormInput = () => {
    const props = {
      addonBefore: (
        <div className={'flex w-20 items-center gap-3'}>
          {getSocialLinkIcon(social, 'fill-brand-primary')}
          <div className={'flex w-full justify-center'}>{getSocialLinkLabel(t, social)}</div>
        </div>
      ),
      value,
      onChange,
      placeholder: getSocialLinkPlaceholder(t, social),
      scheme: social === SocialLinksEnum.whatsapp ? WHATSAPP_SCHEME : undefined,
      ...rest,
    }
    switch (social) {
      case SocialLinksEnum.instagram:
      case SocialLinksEnum.tiktok:
      case SocialLinksEnum.twitter:
      case SocialLinksEnum.telegram:
        return <FormInputMedia {...props} />

      case SocialLinksEnum.email:
        return <FormInput {...props} onChange={e => onChange(e.target.value)} />
      default:
        return <FormInputUrl {...props} />
    }
  }

  return getFormInput()
}

export default FormInputSocial
